export const entityValueQueryKeys = {
    pageAll: (agentId: number, entityId: string) => ["page-entity-values", "agent", agentId, "entity", entityId],
} as const;
